//#region IMPORT
import React from 'react';
import { Box, Divider, ListItemButton, Stack, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import CheckN from '../../../Assets/Images/CheckN.png';
import CheckY from '../../../Assets/Images/CheckY.png';
import { useSelector } from 'react-redux';
import BackClickBottomSheetTbmEnd from '../../../Components/Ui/BackClickBottomSheetTbmEnd';
//#endregion

function M_PPE_BASIC(props) {
  //#region 변수
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  //#endregion

  return (
    <Box sx={{ height: '100%' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        <Box
          sx={{
            m: 2,
            p: 2,
            border: 1,
            borderColor: '#F3F4F6',
            borderRadius: 4,
            backgroundColor: '#fff',
            boxShadow: 0,
          }}
        >
          <Box>
            <Typography fontWeight="bold" mb={1}>
              보호구 체크
              <Typography component="span" sx={{ color: '#AEAEAE' }}>
                ({props.equipList[0]?.managerDepNmLast})
              </Typography>
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>
              {props.equipList.map((item, index) => (
                <ListItemButton
                  key={index}
                  sx={{
                    mt: 1.25,
                    p: 2,
                    py: 1.5,
                    border: 1,
                    borderRadius: 2.5,
                    borderColor: item.equipYn === 'Y' ? '#80CB66' : '#E8E8E8',
                    backgroundColor: item.equipYn === 'Y' ? '#ECF6E8' : '#fff',
                    '&:focus': {
                      outline: 'none', // 포커스 상태에서 기본 테두리 제거
                      borderColor: item.equipYn === 'Y' ? '#80CB66' : '#E8E8E8', // 포커스 상태에서 색상 유지
                      backgroundColor:
                        item.equipYn === 'Y' ? '#ECF6E8' : '#fff', // 배경 색상도 수정 가능
                    },
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    props.setEquipList((prevState) => {
                      return prevState.map((equip) => {
                        if (equip.erCd === item.erCd) {
                          return {
                            ...equip,
                            equipYn: equip.equipYn === 'Y' ? 'N' : 'Y',
                          };
                        }
                        return equip;
                      });
                    });
                  }}
                >
                  <Typography sx={{ fontWeight: 'bold' }}>
                    {item.equipNm}
                  </Typography>
                  <img
                    src={item.equipYn === 'Y' ? CheckY : CheckN}
                    alt="체크 이미지"
                  />
                </ListItemButton>
              ))}
            </Box>
          </Box>
        </Box>
        <Box sx={{ m: 2, mt: 0 }}>
          <Button
            name="완료"
            variant="contained"
            fullWidth
            onClick={() => {
              props.SaveLogic1();
            }}
            sx={{
              height: '36px',
              borderRadius: '18px',
              backgroundColor: '#2DB400',
              '&:hover': {
                backgroundColor: '#26a300',
              },
            }}
          />
        </Box>
      </Stack>
      {bottomSheetState.bottom &&
        bottomSheetState.type === 'backClickTbmEnd' && (
          <BackClickBottomSheetTbmEnd open={bottomSheetState.bottom} />
        )}
    </Box>
  );
}

export default M_PPE_BASIC;
